module.exports = __webpack_public_path__ + "img/img_roll_hover.cf5f3072.svg";